<template>
  <div>
    <br />
    <div class="row m-0 p-0">
      <div class="btn-group float-right pl-2">
        <button
          type="button"
          class="btn btn-default btn-lg"
          style="cursor: pointer"
          data-toggle="tooltip"
          data-placement="right"
          title="Traza Viaje"
        >
          <input
            type="checkbox"
            v-model="form.traza"
            @change="getDatosMapa()"
          />
          <b>
            <i style="font-size: 25px" class="fas fa-map-marked-alt p-1"></i>
          </b>
        </button>
      </div>
      <div class="btn-group float-right pl-2">
        <button
          type="button"
          class="btn btn-default btn-lg"
          style="cursor: pointer"
          data-toggle="tooltip"
          data-placement="right"
          title="Traza Novedades"
        >
          <input
            type="checkbox"
            v-model="form.novedades"
            @change="getNovedades()"
          />
          <b>
            <i style="font-size: 25px" class="fas fa-exclamation-triangle"></i>
          </b>
        </button>
      </div>
      <!--       <div class="btn-group float-right pl-2">
        <button
          type="button"
          class="btn bg-gradient-success btn-lg shadow-sm"
          @click="generarListadoExcel()"
        >
          <i class="far fa-file-excel"></i>
        </button>
      </div> -->
    </div>
    <hr />
    <div class="col">
      <gmap-map :center="center" :zoom="15" style="width: 100%; height: 480px">
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>
        <gmap-polygon
          :options="{ fillColor: '#FF0000' }"
          v-for="poligono in poligonos"
          :key="poligono.id"
          :paths="poligono.path"
          :editable="false"
          :draggable="false"
          @click="toggleInfoWindowPoli(poligono, poligono.id, poligono.info)"
        />
        <gmap-circle
          v-for="circular in circunferencias"
          :key="circular.id"
          :center="circular.center"
          :radius="circular.radius"
          :info="circular.info"
          @click="toggleInfoWindowCir(circular, circular.id, circular.info)"
        ></gmap-circle>
        <gmap-polyline
          v-if="pathRuta.length > 0"
          :options="polylineOptions"
          :path="pathRuta"
          :editable="false"
          ref="polyline"
        >
        </gmap-polyline>
      </gmap-map>
    </div>

    <div class="mt-4" v-if="form.novedades">
      
        <div class="card-body table-responsive p-0" style="height: 300px;">
            <div class="row">

                <table
                  class="table table-head-fixed text-nowrap   table-hover   "
                >
                  <thead >
                    <tr>
                      <th class="text-center">Icono</th>
                      <th class="pl-1">Vehículo</th>
                      <th>Fecha Novedad</th>
                      <th>Posición</th>
                      <th>Velocidad</th>
                      <th>Tipo Novedad</th>
                      <th>Novedad</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="novedad in novedades"
                      :key="novedad.id"
                      @click="mostrarEnMapa(novedad)"
                    >
                      <td class="text-center">
                        <img
                          :src="novedad.icon"
                          alt="Icono"
                          style="width: 24px; height: 24px;"
                        />
                      </td>
                      <td>{{ novedad.vehiculo.placa }}</td>
                      <td>{{ novedad.fecha_inicio ? novedad.fecha_inicio   : novedad.fecha_novedad }}</td>
                      <td>{{novedad.sitio ? novedad.sitio.latitud : novedad.latitud }}, {{ novedad.sitio ? novedad.sitio.longitud : novedad.longitud }}</td>
                      <td>
                        {{ novedad.velocidad ? novedad.velocidad + " Km/h" : "" }}
                      </td>
                      <td>{{ novedad.nTipoNovedad ?? "Inspeccion" }}</td>
      
                      <td>
                        {{ novedad.nSubNovedad ?? novedad.observaciones }}
                        <span v-if="novedad.icon2">
                          -
                          <img
                            :src="novedad.icon2"
                            alt="Icono"
                            style="width: 24px; height: 24px;"
                          />
                        </span>
                      </td>
                    </tr>
                    <!--               <tr>
                      <td></td>
                      <td>
                        {{ $parent.datos.viaje.guia.det_guias[0].vehiculo.placa }}
                      </td>
                      <td>
                        {{
                          new Date(
                            $parent.datos.viaje.guia.det_guias[0].fecha_expedicion
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          $parent.datos.viaje.guia.det_guias[0].sitio_origen.latitud
                        }},{{
                          $parent.datos.viaje.guia.det_guias[0].sitio_origen.longitud
                        }}
                      </td>
                      <td></td>
                      <td>Creacion Guia</td>
                      <td>
                        {{
                          $parent.datos.viaje.guia.det_guias[0].novedades[0]
                            .descripcion
                        }}
                      </td>
                    </tr> -->
                  </tbody>
                </table>
            </div>
        </div>
      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "Mapas",

  data() {
    return {
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        geocercas: false,
        traza: false,
        novedades: false,
      },
      polylineOptions: {
        strokeColor: "#ff1c79",
        strokeOpacity: "0.7",
        strokeWeight: 8,
      },
      center: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      markersAd: [],
      markersEm: [],
      markersGui: [],
      markersGuides: [],
      markersIns: [],
      pathRuta: [],
      pathPoli: [],
      places: [],
      currentPlace: null,
      locations: {},
      poligonos: [],
      circunferencias: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      path: [],
      novedades: [],

      det_mapa: [],
      det_ruta: [],
    };
  },

  methods: {
    getDatosMapa() {
      this.det_mapa = [];
      this.det_ruta = [];
      axios
        .get("/api/hidrocarburos/faltantes/mapa", {
          params: {
            viaje_id: this.$parent.datos.viaje_id,
          },
        })
        .then((response) => {
          this.det_mapa = response.data.posiciones;
          this.det_ruta = response.data.ruta;
          console.log(this.det_mapa);
          this.getTrazabilidad();
        });
      /*
       */
    },
    async getTrazabilidad() {
      this.puntosTraza = [];
      this.markers = [];
      if (this.form.traza) {
        this.puntosTraza = this.det_mapa;
        this.trazaViaje();
        await this.getRuta();
      }
    },

    trazaViaje() {
      if (this.puntosTraza.length > 0) {
        for (let index = 0; index < this.puntosTraza.length; index++) {
          const marker = {
            lat: parseFloat(this.puntosTraza[index].latitud),
            lng: parseFloat(this.puntosTraza[index].longitud),
          };
          this.markers.push({
            id: this.puntosTraza[index].id,
            position: marker,
            icon: "/img/icon_punt_ruta.png",
            info: this.puntosTraza[index].ventana,
          });
        }
        this.puntoInicialLat = parseFloat(this.puntosTraza[0].latitud);
        this.puntoInicialLng = parseFloat(this.puntosTraza[0].longitud);
        this.infoPuntoInicial = this.puntosTraza[0].ventana;

        this.markers.push({
          id: this.puntosTraza[0].id,
          position: {
            lat: this.puntoInicialLat,
            lng: this.puntoInicialLng,
          },
          icon: "/img/icon_punto_g_ok.png",
          info: this.infoPuntoInicial,
        });

        this.puntofin = this.puntosTraza.slice(-1);
        this.puntoFinalLat = parseFloat(this.puntofin[0].latitud);
        this.puntoFinalLng = parseFloat(this.puntofin[0].longitud);
        this.infoPuntoFinal = this.puntofin[0].ventana;

        this.markers.push({
          id: this.puntofin[0].id,
          position: {
            lat: this.puntoFinalLat,
            lng: this.puntoFinalLng,
          },
          icon: "/img/icon_punto_g.png",
          info: this.infoPuntoFinal,
        });

        const marker1 = {
          lat: this.puntoFinalLat,
          lng: this.puntoFinalLng,
        };
        this.center = marker1;
      } else {
        this.$refs.closeModal.click();
        this.$swal({
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
      }
    },

    async getNovedades() {
      this.path = [];
      this.markersAd = [];
      this.markersEm = [];
      this.markersIns = [];
      this.markersGui = [];
      this.markersGuides = [];
      this.$parent.cargando = true;
      let me = this;
      await axios
        .get("/api/hidrocarburos/faltantes/novedadesMapa", {
          params: { viaje: me.$parent.datos.viaje_id },
        })
        .then(async function(response) {
          me.markersAd = [];
          me.markersEm = [];
          me.markersIns = [];
          me.markersGui = [];
          me.markersGuides = [];

          const datosNovedades = response.data.advertencia;
          if (me.form.novedades == true) {
            await datosNovedades.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                let ventana =
                  '<div class="wrapper"><h3 style="font-size:15px" class="text-center">Vehículo: ' +
                  nov.vehiculo.placa +
                  "</h3><hr><b>Fecha novedad: </b> " +
                  nov.fecha_novedad +
                  "<br> <b>Viaje: </b>" +
                  nov.viaje_id +
                  "<br> <b>Transportadora: </b>" +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  "<br> <b>Posicion: </b>" +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  "<br> <b>Velocidad: </b> " +
                  nov.velocidad +
                  " Km/h" +
                  "<br> <b>Novedad: </b>" +
                  nov.nTipoNovedad +
                  " - " +
                  nov.nSubNovedad;
                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };

                me.markersAd.push({
                  position: marker,
                  icon: nov.icon,
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });

            const datosNovedadesEmerg = response.data.emergencia;
            await datosNovedadesEmerg.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                let ventana =
                  '<div class="wrapper"><h3 style="font-size:15px" class="text-center">Vehículo: ' +
                  nov.vehiculo.placa +
                  "</h3><hr><b>Fecha novedad: </b> " +
                  nov.fecha_novedad +
                  "<br> <b>Viaje: </b>" +
                  nov.viaje_id +
                  "<br> <b>Transportadora: </b>" +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  "<br> <b>Posicion: </b>" +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  "<br> <b>Velocidad: </b> " +
                  nov.velocidad +
                  " Km/h" +
                  "<br> <b>Novedad: </b>" +
                  nov.nTipoNovedad +
                  " - " +
                  nov.nSubNovedad;

                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };
                me.markersEm.push({
                  position: marker,
                  icon: nov.icon,
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });

            const datosNovedadesInspe = response.data.gps;
            await datosNovedadesInspe.forEach((nov) => {
            
            
              if (nov.viaje_id) {
                let ventana =
                  '<div class="wrapper"><h3 style="font-size:15px" class="text-center">Vehículo: ' +
                  nov.vehiculo.placa +
                  "</h3><hr><b>Fecha novedad: </b> " +
                  nov +
                  "<br> <b>Viaje: </b>" +
                  nov.viaje_id +
                  "<br> <b>Transportadora: </b>" +
                  (nov.empresa
                    ? nov.empresa.razon_social
                    : "Sin asignar") +
                  "<br> <b>Posicion: </b>" +
                  nov.sitio.latitud +
                  ", " +
                  nov.sitio.longitud +
                  "<br> <b>Velocidad: </b> " +
                  nov.velocidad +
                  " Km/h" +
                  "<br> <b>Novedad: </b>" +
                 
                  " Inspeccion " +
                  nov.observaciones	 +
                  nov.icon;
                const marker = {
                  lat: parseFloat(nov.sitio.latitud),
                  lng: parseFloat(nov.sitio.longitud),
                };

                me.markersIns.push({
                  position: marker,
                  icon: nov.icon,
                  info: ventana,

                  center: {
                    marker,
                  },
                });
              }
            });

            let datosNovedadesGuiades = [];

            if (me.$parent.datos) {
              datosNovedadesGuiades.push({
                desc: me.$parent.datos.viaje.guia.det_guias[0].vehiculo.placa,
                vehiculo: me.$parent.datos.viaje.guia.det_guias[0].vehiculo,
                direccion:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_origen
                    .dirreccion,
                fecha_novedad: moment(
                  me.$parent.datos.viaje.guia.cierre_guias[0].created_at
                ).format("YYYY-MM-DD HH:mm:ss"),

                latitud:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino
                    .latitud,
                longitud:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino
                    .longitud,
                nTipoNovedad: "CIERRE GUIA",
                nSubNovedad:
                  me.$parent.datos.viaje.guia.cierre_guias[0].novedades[0]
                    .Nnovedad,
                viaje_id: me.$parent.datos.viaje.id,
                viaje: me.$parent.datos.viaje,
                velocidad: "",
                icon: "/img/icons/guiades-icon.png",
              });

              datosNovedadesGuiades.push({
                desc: me.$parent.datos.viaje.guia.det_guias[0].vehiculo.placa,
                vehiculo: me.$parent.datos.viaje.guia.det_guias[0].vehiculo,
                direccion:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_origen
                    .dirreccion,
                fecha_novedad: moment(
                  me.$parent.datos.viaje.guia.cierre_guias[0].created_at
                ).format("YYYY-MM-DD HH:mm:ss"),

                latitud:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino
                    .latitud,
                longitud:
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino
                    .longitud,
                nTipoNovedad: "CIERRE GUIA",
                nSubNovedad:
                  me.$parent.datos.viaje.guia.cierre_guias[0].novedades[1]
                    .Nnovedad,
                viaje_id: me.$parent.datos.viaje.id,
                viaje: me.$parent.datos.viaje,
                velocidad: "",
                icon: "/img/icons/guiades-icon.png",
              });

              const marker = {
                lat: parseFloat(
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino.latitud
                ),
                lng: parseFloat(
                  me.$parent.datos.viaje.guia.det_guias[0].sitio_destino
                    .longitud
                ),
              };

              // Agrega el marcador a `me.markersGui`
              me.markersGuides.push({
                position: marker,
                icon: "/img/icons/guiades-icon.png",
                /*               info: ventana,
                 */
                center: {
                  marker,
                },
              });
            }

            let datosNovedadesGuia = [];

            // Crea un objeto para cada "novedad" y agrégalo al array
            datosNovedadesGuia.push({
              desc: me.$parent.datos.viaje.guia.det_guias[0].vehiculo.placa,
              vehiculo: me.$parent.datos.viaje.guia.det_guias[0].vehiculo,
              direccion:
                me.$parent.datos.viaje.guia.det_guias[0].sitio_origen
                  .dirreccion,
              fecha_novedad:
                me.$parent.datos.viaje.guia.det_guias[0].fecha_expedicion,
              latitud:
                me.$parent.datos.viaje.guia.det_guias[0].sitio_origen.latitud,
              longitud:
                me.$parent.datos.viaje.guia.det_guias[0].sitio_origen.longitud,
              nTipoNovedad: "CREACION GUIA",
              nSubNovedad:
                me.$parent.datos.viaje.guia.det_guias[0].novedades[0]
                  .descripcion,
              viaje_id: me.$parent.datos.viaje.id,
              viaje: me.$parent.datos.viaje,
              velocidad: "",
              icon: "/img/icons/guia-icon.png",
            });

            // Ahora puedes iterar con forEach

            let ventana =
              '<div class="wrapper"><h3 style="font-size:15px" class="text-center">Vehículo: ' +
              datosNovedadesGuia.desc +
              "</h3><hr><b>Fecha novedad: </b> " +
              datosNovedadesGuia.fecha_novedad +
              "<br> <b>Viaje: </b>" +
              (datosNovedadesGuia.guia
                ? datosNovedadesGuia.guia.viaje_id
                : "Sin viaje") +
              "<br> <b>Transportadora: </b>" +
              (datosNovedadesGuia.transportadora
                ? datosNovedadesGuia.transportadora.razon_social
                : "Sin asignar") +
              "<br> <b>Posición: </b>" +
              datosNovedadesGuia.latitud +
              ", " +
              datosNovedadesGuia.longitud +
              "<br> <b>Velocidad: </b> " +
              (datosNovedadesGuia.velocidad
                ? datosNovedadesGuia.velocidad
                : "") +
              "<br> <b>Novedad: </b>" +
              (datosNovedadesGuia.novedades &&
              datosNovedadesGuia.novedades.length > 0
                ? datosNovedadesGuia.novedades[0].descripcion
                : "Sin novedades") +
              datosNovedadesGuia.icon;

            // Crear el marcador con latitud y longitud
            const marker = {
              lat: parseFloat(
                me.$parent.datos.viaje.guia.det_guias[0].sitio_origen.latitud
              ),
              lng: parseFloat(
                me.$parent.datos.viaje.guia.det_guias[0].sitio_origen.longitud
              ),
            };

            // Agrega el marcador a `me.markersGui`
            me.markersGui.push({
              position: marker,
              icon: "/img/icons/guia-icon.png",
              info: ventana,

              center: {
                marker,
              },
            });

            // Combinar todas las novedades en `me.novedades`
            me.novedades = datosNovedades.concat(
              datosNovedadesInspe,
              datosNovedadesEmerg,
              datosNovedadesGuia,
              datosNovedadesGuiades
            );
          }

          me.$parent.cargando = false;
        })
        .catch(function(error) {
          me.$parent.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getRuta() {
      this.pathRuta = [];
      this.pathPoli = this.det_ruta;
      if (this.pathPoli.length > 0) {
        for (let i = 0; i < this.pathPoli.length; i++) {
          if (i == 0) {
            this.pathRuta.push({
              lat: parseFloat(this.pathPoli[i].lat_ini),
              lng: parseFloat(this.pathPoli[i].lon_ini),
            });
          }
          this.pathRuta.push({
            lat: parseFloat(this.pathPoli[i].lat_fin),
            lng: parseFloat(this.pathPoli[i].lon_fin),
          });
        }
      }
    },
    mostrarEnMapa(novedad) {
      this.center = {
        lat: parseFloat(novedad.latitud ?? novedad.sitio.latitud),
        lng: parseFloat(novedad.longitud ?? novedad.sitio.longitud),
      };
      this.infoWindowPos = {
        lat: parseFloat(novedad.latitud ?? novedad.sitio.latitud),
        lng: parseFloat(novedad.longitud ?? novedad.sitio.longitud),
      };
      this.infoContent = `
 <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-bottom: 10px;">
      ${
        novedad.icon2
          ? `<div class="parpadea">
              <img src="${novedad.icon2}" alt="Icono" style="width: 35px; height: 35px;" />
             </div>`
          : ""
      }
      <h3 style="font-size:15px; margin: 0; line-height: 35px;">Vehículo: ${
        novedad.vehiculo.placa 
      }</h3>
    </div>
    <div>
      <hr style="margin: 5px 0;">
      <b>Fecha novedad: </b>${novedad.fecha_novedad ?? novedad.fecha_inicio } ${ novedad.hora_inicio ?? "" }
      <br> <b>Viaje: </b>${novedad.viaje_id}
      <br> <b>Transportadora: </b>${
        novedad.viaje
          ? novedad.viaje.transportadora.razon_social
          : novedad.empresa.razon_social
      }
      <br> <b>Posición: </b>${novedad.latitud ?? novedad.sitio.latitud}, ${novedad.longitud ?? novedad.sitio.longitud}
      <br> <b>Velocidad: </b>${novedad.velocidad ?? "0"} Km/h
      <br> <b>Novedad: </b>${novedad.nTipoNovedad ?? novedad.observaciones } - ${novedad.nSubNovedad ?? ""}
    </div>`;
      this.infoWinOpen = true;
    },

    toggleInfoWindow: function(marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    limpiarTrazabilidadYNovedades() {
      this.puntosTraza = [];
      this.markers = [];
      this.novedades = [];
      this.det_mapa = [];
      this.det_ruta= [];
      this.form.novedades = false;
      this.form.traza = false;
      this.form.geocercas = false;
    },

    generarListadoExcel() {
      let viaje_id = this.$parent.viaje_id;
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/trazaExport",
        data: { viaje_id },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
};
</script>
<style>
.parpadea {
  animation-name: parpadeo;
  animation-duration: 0.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name: parpadeo;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes parpadeo {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes parpadeo {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
